import type { MonospaceServiceAccount, MonospaceSystemWorkspaceMember } from '#layers/data-model/public';
import { defineRelations, withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { compositeKey } from '~/rstore/utils/composite-key';
import { Workspace } from './workspace';

export const ServiceAccount = withItemType<MonospaceServiceAccount>().defineCollection({
	name: 'MonospaceServiceAccount',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: [
			'id',
			'fullName',
		],
		endpoint: 'system/service-accounts',
	},
});

// Junction table between User/ServiceAccount and Workspace
export const SystemWorkspaceMember = withItemType<MonospaceSystemWorkspaceMember>().defineCollection({
	name: 'MonospaceWorkspaceMember',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => compositeKey(item.userId, item.workspaceId),
	meta: {
		defaultFields: ['userId', 'workspaceId'],
	},
});

export const ServiceAccountRelations = defineRelations(ServiceAccount, ({ collection }) => ({
	workspaces: {
		to: collection(SystemWorkspaceMember, {
			on: {
				'MonospaceWorkspaceMember.userId': 'MonospaceServiceAccount.id',
			},
		}),
		many: true,
	},
}));

export const SystemWorkspaceMemberRelations = defineRelations(SystemWorkspaceMember, ({ collection }) => ({
	workspace: {
		to: collection(Workspace, {
			on: {
				'MonospaceWorkspace.id': 'MonospaceWorkspaceMember.workspaceId',
			},
		}),
	},
}));
